<template>
  <div class="queryMember">
    <div class="addExperiment-title">
      <span @click="goRouter('/college')">学院管理&nbsp;&nbsp; / &nbsp;&nbsp;</span>
      <i>成员</i>
    </div>
    <div class="result-container">
      <div class="tabs-list">
        <div
          class="list"
          @click="toggleTab(0)"
          :class="active == 0 ? 'result-active-tabs' : ''"
        >
          老师
        </div>
        <div
          class="list"
          @click="toggleTab(1)"
          :class="active == 1 ? 'result-active-tabs' : ''"
        >
          学生
        </div>
      </div>
      <div class="btnList">
        <el-input
          placeholder="请输入成员名字"
          v-model="input4"
          class="searchInput"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <div class="btn1">添加成员</div>
        <div class="btn2">导入成员</div>
        <div class="download">
          <img src="@/assets/images/common/download.png" alt="" />
          <span>下载模板</span>
        </div>
      </div>
    </div>
    <div class="content-tables">
      <template v-if="active == 0">
        <el-table :data="tableData" style="width: 100%" key="0">
          <el-table-column prop="name" label="ID"></el-table-column>
          <el-table-column prop="name" label="名字"></el-table-column>
          <el-table-column prop="name" label="电话"></el-table-column>
          <el-table-column prop="name" label="邮箱"></el-table-column>
          <el-table-column prop="name" label="性别"></el-table-column>
          <el-table-column  width="200">
            <template slot="header">
              <span class="fontSizeCenter">操作</span>
            </template>
            <p class="operation"><span>禁用</span><i>|</i><span>删除</span></p>
          </el-table-column>
        </el-table>
      </template>
      <template v-if="active == 1">
        <el-table :data="tableData" style="width: 100%" key="1">
          <el-table-column prop="name" label="ID"></el-table-column>
          <el-table-column prop="name" label="名字"></el-table-column>
          <el-table-column prop="name" label="电话"></el-table-column>
          <el-table-column prop="name" label="邮箱"></el-table-column>
          <el-table-column prop="name" label="学院"></el-table-column>
          <el-table-column prop="name" label="班级"></el-table-column>
          <el-table-column prop="name" label="性别"></el-table-column>
          <el-table-column  width="200">
            <template slot="header">
              <span class="fontSizeCenter">操作</span>
            </template>
            <p class="operation"><span>禁用</span><i>|</i><span>删除</span></p>
          </el-table-column>
        </el-table>
      </template>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage4"
        :page-sizes="[100, 200, 300, 400]"
        :page-size="100"
        layout="total, sizes, prev, pager, next, jumper"
        :total="400"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "VirtualimitationQueryresults",

  data() {
    return {
      isaddCollege: false,
      active: 0,
      checked: true,
      input4: "",
      currentPage4: 1,
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄",
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄",
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1516 弄",
        },
      ],
    };
  },

  mounted() {},

  methods: {
    toggleTab(index) {
      this.active = index;
    },
    handleSizeChange(val) {
    },
    handleCurrentChange(val) {
    },
    goRouter(path){
       this.$router.push(path)
    }
  },
};
</script>

<style lang="less" scoped>
.queryMember {
  width: 100%;
  .result-container {
    padding: 22px 24px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    .btnList {
      display: flex;
      justify-content: start;
      align-items: center;
      .el-input {
        width: 370px;
        /deep/ .el-input__inner {
          height: 36px;
          line-height: 36px;
        }
      }

      .download {
        margin-left: 22px;
        display: flex;
        justify-content: start;
        align-items: center;
        img {
          width: 14px;
          height: 14px;
          margin-right: 3px;
        }
        span {
          font-size: 14px;
          font-family: PingFang-SC;
          font-weight: 400;
          line-height: 20px;
          color: #1880fa;
        }
      }
      .btn1,
      .btn2 {
        width: 94px;
        height: 36px;
        background: #fff;
        border-radius: 6px;
        font-size: 14px;
        font-family: PingFang-SC;
        font-weight: 400;
        line-height: 20px;
        color: #1880fa;
        border: 1px solid #1880fa;
        box-sizing: border-box;
        text-align: center;
        line-height: 36px;
        cursor: pointer;
      }
      .btn1 {
        background: #1880fa;
        color: #fff;
        margin: 0 18px 0 58px;
      }
    }
    .tabs-list {
      display: flex;
      justify-content: start;
      .list {
        margin-right: 67px;
        width: 56px;
        height: 25px;
        font-size: 14px;
        font-family: PingFang-SC;
        font-weight: 500;
        line-height: 20px;
        color: #101012;
        opacity: 1;
        cursor: pointer;
        text-align: center;
      }
    }
  }
  .content-tables {
    padding: 0 24px 55px;
    background: #fff;
    padding-bottom: 55px;
  }
  /deep/ .operation {
    text-align: center;
    color: #409eff;
    i {
      font-style: normal;
      margin: 0 15px;
      color: #99a7c3;
    }
    span {
      cursor: pointer;
      font-size: 14px;
      font-family: PingFang-SC;
      font-weight: 400;
      line-height: 20px;
      color: #1880fa;
    }
  }
  .el-pagination {
    text-align: center;
    margin-top: 50px;
    margin-bottom: 16px;
  }
  .el-table {
    //   padding: 24px;
    width: calc(100% - 48px);
    box-sizing: border-box;
  }
  .el-table /deep/ thead th .cell {
    color: #99a7c3;
  }
  /deep/ .el-table_1_column_6,
  .el-table_1_column_5 {
    text-align: center;
  }
}
.addExperiment-title {
  margin-bottom: 16px;
  span,
  i {
    font-size: 14px;
    font-family: PingFang-SC;
    font-weight: 400;
    line-height: 20px;
    color: #424346;
    font-style: normal;
    opacity: 1;
  }
  span {
    color: #939393;
    cursor: pointer;
  }
}
.result-active-tabs {
  border-bottom: 2px solid #1880fa;
  color: #1880fa !important;
}
.fontSizeCenter {
  display: inline-block;
  width: 100%;
  text-align: center;
}
</style>